import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/common.json';
import it from './locales/it/common.json';
import fr from './locales/fr/common.json';
import es from './locales/es/common.json';
import de from './locales/de/common.json';

const supportedLanguages = ['en', 'it', 'fr', 'es', 'de'];

function detectInitialLanguage() {
  const storedLanguage = localStorage.getItem('fb_lang');
  if (storedLanguage && supportedLanguages.includes(storedLanguage)) {
    return storedLanguage;
  }

  const browserLanguage = (navigator.language || navigator.userLanguage || 'en').split('-')[0].toLowerCase();
  return supportedLanguages.includes(browserLanguage) ? browserLanguage : 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      it: { common: it },
      fr: { common: fr },
      es: { common: es },
      de: { common: de },
    },
    lng: detectInitialLanguage(),
    fallbackLng: 'en',
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
  });

export default i18n;
